import styled from "styled-components";
import { CSVLink } from "react-csv";
import { buildExcelExportTable } from "./reportExport";
import Button from "../../components/Button";
import Spacer from "../../components/Spacer";
import backIcon from "../../assets/back_icon.svg";
import { useTranslation } from "react-i18next";

//region CSS
const MyView = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  box-sizing: border-box;
  padding: 30px 20px;
  max-height: 1024px;
`;
const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 75px;
  min-height: 75px;
  border-bottom: 1px solid #a7bbcf;
`;
const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  width: 304px;
  min-width: 304px;
`;
const BackButton = styled.img`
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-right: 20px;
`;
const ReportTitle = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 33px;
  color: #454b60;
`;
//endregion

const ReportExcelExporter = ({
  title,
  headers,
  rows,
  onBack,
  columnSums,
  columnAverages,
}) => {
  const { t } = useTranslation("reportViewer");

  /* JFCRX-7649. `rows` arrive FLAT, in the order the grid shows them: from
   * getOnScreenExportRows for the on-screen set, or from orderExportRowsByGroup
   * for the whole set a paginated viewer fetched. The table is built by a pure
   * helper on every render, no state and no effect, so the render loop
   * JFCRX-6782 fixed in the old effect (a grouped array rebuilt on every
   * render, named in the effect's dependencies) has nothing left to
   * re-trigger it. Not memoised: the grouped callers hand over a fresh array
   * each render, so a memo keyed on `rows` could never hit, and CSVLink
   * rebuilds its href on every render regardless.
   *
   * The rows are written positionally against `headers`, as the paginated path
   * has done since JFCRX-6732: keyed by header string, two columns with the
   * same display name collapsed into one. */
  const table = buildExcelExportTable({
    headers,
    rows,
    columnSums,
    columnAverages,
  });

  const currentTimeInSeconds = Math.floor(Date.now() / 1000);
  const fileNameForCSV = `report-data-${currentTimeInSeconds}.csv`;

  return (
    <MyView>
      <Header>
        <TitleGroup>
          <BackButton src={backIcon} onClick={onBack} />
          <ReportTitle>{t("excelExporterTitle")}</ReportTitle>
        </TitleGroup>
      </Header>
      <Spacer unit={"px"} space={50} />
      <CSVLink
        data={table.rows}
        headers={table.headers}
        separator={","}
        filename={fileNameForCSV}
      >
        <Button
          isPrimary={true}
          minWidth={"123px"}
          labelName={t("downloadButtonLabel")}
        />
      </CSVLink>
    </MyView>
  );
};

export default ReportExcelExporter;
